import { StyledBox, StyledTypography } from './DetailLink.styles';

interface DetailLinkProps {
  onClick: () => void;
  label: string;
}

const DetailLink = ({ onClick, label }: DetailLinkProps) => (
  <StyledBox onClick={onClick}>
    <StyledTypography>{label}</StyledTypography>
  </StyledBox>
);

export default DetailLink;
